let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dFNh6")).then(() => parcelRequire('8g9bp'));